import React from 'react';
import { Scale, XCircle } from 'lucide-react';
import { Section } from './ui/Section';
const costs = [{
  sin: '3 horas de planificación × 40 semanas de clases',
  costo: '120 horas de tu vida por año'
}, {
  sin: 'Evaluaciones de Historia y Geografía sin rúbricas ni criterios claros',
  costo: 'Fines de semana de corrección sin norte'
}, {
  sin: 'Material de Física y Química no alineado al Programa EBI vigente',
  costo: 'Tensión con dirección · con inspección y con vos misma'
}, {
  sin: 'Ciudadanía y Ciencias de la Tierra sin articulación ni secuencia real',
  costo: 'Clases desconectadas que confunden a los niños'
}, {
  sin: 'Domingo buscando en Google · en grupos en carpetas viejas',
  costo: 'El mismo ciclo · el próximo año · y el siguiente'
}];
export const CostOfInaction = () => {
  return <Section background="white" data-id="element-39">
      <div className="max-w-4xl mx-auto" data-id="element-40">
        <div className="text-center mb-12" data-id="element-41">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-stone-100 text-stone-600 mb-6" data-id="element-42">
            <Scale className="w-8 h-8" data-id="element-43" />
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-stone-900" data-id="element-44">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-stone-200 overflow-hidden mb-12" data-id="element-45">
          <div className="grid md:grid-cols-2 bg-stone-50 border-b border-stone-200" data-id="element-46">
            <div className="p-5 font-bold text-stone-700 flex items-center gap-2" data-id="element-47">
              <XCircle className="w-5 h-5 text-stone-400" data-id="element-48" /> SIN AULA DE
              ÉXITOS™
            </div>
            <div className="p-5 font-bold text-stone-700 md:border-l border-stone-200" data-id="element-49">
              El costo real que no se ve
            </div>
          </div>

          <div className="divide-y divide-stone-100" data-id="element-50">
            {costs.map((item, idx) => <div key={idx} className="grid md:grid-cols-2 hover:bg-stone-50/50 transition-colors" data-id="element-51">
                <div className="p-4 md:p-5 text-stone-600 font-medium" data-id="element-52">
                  {item.sin}
                </div>
                <div className="p-4 md:p-5 text-stone-900 font-bold md:border-l border-stone-100 bg-stone-50/30" data-id="element-53">
                  {item.costo}
                </div>
              </div>)}
          </div>
        </div>

        <div className="text-center bg-celeste-50 rounded-2xl p-8 border border-celeste-100" data-id="element-54">
          <p className="text-2xl md:text-3xl font-extrabold text-stone-900 mb-2" data-id="element-55">
            "El próximo fin de semana puede ser diferente."
          </p>
          <p className="text-xl font-bold text-celeste-700 uppercase tracking-wide" data-id="element-56">
            Y el siguiente. ES UN HECHO.
          </p>
        </div>
      </div>
    </Section>;
};